var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{class:{
        'json-schema-editor': true,
        'invalid': _vm.hasErrors
    }},[_c('textarea',{ref:"editor"}),(_vm.hasErrors)?_c('v-tooltip',{attrs:{"top":"","allow-overflow":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
    var on = ref.on;
    var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"error-alert",attrs:{"color":"red"}},'v-icon',attrs,false),on),[_vm._v(" mdi-alert-circle-outline ")])]}}],null,false,2505925405),model:{value:(_vm.showErrors),callback:function ($$v) {_vm.showErrors=$$v},expression:"showErrors"}},[_c('ol',_vm._l((_vm.validationErrors),function(error,index){return _c('li',{key:index},[_vm._v(_vm._s(error))])}),0)]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }